import Loadable from '../../components/loadable';

const PasswordStrength = Loadable({
  loader: () => import('../../components/password_strength'),
});

angular.module('shared').value('PasswordStrength', PasswordStrength);
